import React from "react";

type IProps = React.HTMLAttributes<HTMLParagraphElement>;

export const RadioDescription: React.FC<IProps> = (props) => (
  <span {...props} className="fs-radio__description" />
);
